import moment from 'moment'
import store from '../../store/store'
import momentUtcToUserTz from './momentUtcToUserTz'

export const isDeviceTimezoneMode = () => {
	return store.getState().user.user.settings.time_zone === 'device'
}

export const TIMEZONE_LABELS = {
	'America/Anchorage': 'US/Alaska',
	'America/Chicago': 'US/Central',
	'America/Denver': 'US/Mountain',
	'America/Detroit': 'US/Michigan',
	'America/Fort_Wayne': 'US/East-Indiana',
	'America/Indiana/Knox': 'US/Indiana-Starke',
	'America/Los_Angeles': 'US/Pacific',
	'America/New_York': 'US/Eastern',
	'America/Phoenix': 'US/Arizona',
	'Pacific/Honolulu': 'US/Hawaii',
}

export const getTimezoneLabel = (timeZone) => {
	return TIMEZONE_LABELS[timeZone] || timeZone || ''
}

export const toDateOnlyParam = (ts) => {
	if (!ts) {
		return ts
	}

	return moment.utc(String(ts), 'YYYYMMDDHHmmss').local().format('YYYYMMDD')
}

export const toDateRangeParams = (startTs, endTs) => {
	return isDeviceTimezoneMode()
		? `start_date=${toDateOnlyParam(startTs)}&end_date=${toDateOnlyParam(endTs)}`
		: `start_ts=${startTs}&end_ts=${endTs}`
}

export const convertRangeToDateOnly = (params, startKey, endKey) => {
	if (!isDeviceTimezoneMode()) {
		return params
	}

	if (params[startKey]) {
		params.start_date = toDateOnlyParam(params[startKey])
		delete params[startKey]
	}
	if (params[endKey]) {
		params.end_date = toDateOnlyParam(params[endKey])
		delete params[endKey]
	}

	return params
}

export const formatWithZoneAbbr = (momentObj, format) => {
	if (!momentObj) {
		return ''
	}

	return `${momentObj.format(format)} (${momentObj.zoneAbbr()})`
}

export const formatWithZoneAbbrNode = (momentObj, format) => {
	if (!momentObj) {
		return ''
	}

	return <>{momentObj.format(format)} <span className="timezone-abbr">({momentObj.zoneAbbr()})</span></>
}

export const toStartDateParams = (startTs) => {
	if (isDeviceTimezoneMode()) {
		return `start_date=${toDateOnlyParam(startTs)}`
	}

	const userMoment = momentUtcToUserTz(new Date().toISOString())
	const tz = userMoment.utcOffset()
	const timezone = 'UTC' + ((tz > 0) ? '+' : '') + tz / 60
	const tzname = userMoment.tz()

	return `start_ts=${startTs}&timezone=${timezone}&tzname=${tzname}`
}
